export enum QuoteRequestType {
  Matrix = 'Matrix',
  Custom = 'Custom',
  QuickQuote = 'QuickQuote',
}

